export const ru = {
  common: {
    save: "Сохранить",
    saved: "Сохранено",
    saving: "Сохранение…",
    cancel: "Отмена",
    delete: "Удалить",
    add: "Добавить",
    back: "Назад",
    close: "Закрыть",
    open: "Открыть",
    retry: "Повторить",
    loading: "Загрузка…",
    yes: "Да",
    no: "Нет",
    error: "Ошибка",
    copy: "Скопировать",
    copied: "Скопировано",
    search: "Поиск",
    edit: "Изменить",
    create: "Создать",
    done: "Готово",
    from: "от",
    unsaved: "Есть несохранённые изменения",
  },
  nav: {
    sites: "Сайты",
    subscriptions: "Подписки",
    settings: "Профиль",
    admin: "Админка",
  },
  auth: {
    connecting: "Подключаемся…",
    failed: "Не удалось войти",
    outsideTelegram:
      "Приложение открыто вне Telegram, поэтому работает демо-режим с локальными данными.",
    mockBadge: "Демо-режим",
  },
  sites: {
    title: "Мои сайты",
    hasChanges: "Есть неопубликованные правки",
    empty: "Пока нет ни одного сайта",
    emptyHint: "Создайте первый — публикация на 7 дней бесплатно",
    create: "Новый сайт",
    chooseTemplate: "Выберите шаблон",
    namePlaceholder: "Название сайта",
    nameHint: "Видно только вам — в списке сайтов",
    open: "Открыть",
    deleteConfirm: "Удалить сайт «{{title}}»? Отменить это будет нельзя.",
    limitReached: "Достигнут лимит сайтов по тарифу",
    paidOnce: "Разовая оплата",
    upgrade: "Выбрать тариф",
    status: {
      draft: "Черновик",
      publishing: "Публикуется",
      published: "Опубликован",
      publish_error: "Ошибка публикации",
      expired: "Снят с публикации",
    },
  },
  editor: {
    title: "Конструктор",
    blocks: "Блоки",
    design: "Оформление",
    addBlock: "Добавить блок",
    blockSettings: "Настройки блока",
    noBlocks: "Блоков пока нет — добавьте первый",
    hide: "Скрыть",
    show: "Показать",
    up: "Выше",
    down: "Ниже",
    undo: "Отменить",
    redo: "Вернуть",
    preview: "Предпросмотр",
    publish: "Опубликовать",
    update: "Обновить",
    updateSite: "Обновить сайт",
    unpublishedChanges: "Сайт опубликован, но эти правки ещё не на нём. Обновите публикацию, когда закончите.",
    siteTitle: "Название сайта",
    pageTitle: "Заголовок страницы",
    pageDescription: "Описание для поиска и превью",
    theme: "Тема оформления",
    accent: "Акцентный цвет",
    backgroundPhoto: "Фон-фотография",
    backgroundPhotoHint: "Загрузите снимок — он ляжет на всю страницу",
    removePhoto: "Убрать фото",
    backgroundDim: "Затемнение фото",
    backgroundDimHint: "Чем сильнее, тем лучше читается текст поверх снимка",
    background: "Свой фон (CSS)",
    backgroundHint: "Например: linear-gradient(160deg,#fff,#eee)",
    items: "Элементы",
    addItem: "Добавить «{{label}}»",
    itemNumber: "{{label}} {{number}}",
    imageHint: "Вставьте ссылку на изображение",
    uploadImage: "Загрузить фото",
    saveFailed: "Не удалось сохранить: {{reason}}",
    showPreview: "Показать предпросмотр",
    hidePreview: "Скрыть предпросмотр",
    blockEmpty: "блок пока пустой, откройте и заполните",
    siteMissing: "Сайт удалён — сохранять больше некуда. Откройте список сайтов и создайте новый.",
    backToSites: "К списку сайтов",
  },
  preview: {
    title: "Предпросмотр",
    mobile: "Телефон",
    desktop: "Десктоп",
    refresh: "Обновить",
    serverRender: "Рендер сервера",
    localRender: "Быстрый рендер",
    hint: "Так сайт увидят посетители",
    emptySite: "Добавьте блоки в конструкторе — здесь появится ваш сайт",
    emptyCustomCode: "Напишите HTML — здесь появится ваш сайт",
  },
  customCode: {
    title: "Свой код",
    locked: "Свой код пока не оплачен",
    description:
      "Страница целиком собирается из вашего HTML, CSS и JavaScript — блоков конструктора здесь нет.",
    html: "HTML",
    css: "CSS",
    js: "JavaScript",
    save: "Сохранить код",
    paid: "Оплачено",
    priceHint: "Разовая оплата за один сайт — подписка не нужна. Оплата бессрочная: если удалите сайт, она перейдёт на следующий сайт со своим кодом.",
    priceMissing: "Цена не настроена — напишите администратору",
    buy: "Оплатить {{price}} Gram",
    purchased: "Оплачено — свой код открыт для этого сайта",
    recovered: "Оплата уже есть — свой код открыт, платить не нужно",
    checking: "Проверяем оплату…",
    checkingHint: "Если вы уже оплатили, доступ откроется сам, как только транзакция появится в сети — обычно это меньше минуты. Платить повторно не нужно.",
    payFirst: "Сначала оплатите возможность своего кода",
    uploadImage: "Загрузить фото",
    uploadHint: "Ссылка вставится прямо в код, в текущую вкладку",
    imageInserted: "Фото загружено, ссылка вставлена в код",
    warning:
      "Код попадает на страницу как есть. Проверьте его: ошибка в JS сломает страницу целиком.",
  },
  domain: {
    title: "Домен",
    subtitle: "Получите бесплатный субдомен в зоне платформы — сайт откроется по адресу",
    zoneSuffix: "зона",
    zoneNotReady: "Зона субдоменов ещё не настроена администратором",
    modeSubdomain: "Субдомен платформы",
    modeOwn: "Свой домен .ton",
    ownLabel: "Ваш домен",
    ownHint: "Домен должен принадлежать подключённому кошельку",
    attachOwn: "Привязать домен",
    placeholder: "myname",
    check: "Проверить",
    available: "Домен свободен",
    taken: "Домен занят",
    invalid: "3–125 символов: латиница, цифры и дефис",
    mode: "Тип зоны",
    modeProxy: "Proxy — обычный субдомен",
    modeSbt: "SBT — неотчуждаемый",
    deploy: "Подписать и привязать",
    walletRequired: "Сначала подключите кошелёк",
    connectWallet: "Подключить кошелёк",
    waiting: "Ждём подтверждения транзакции в сети…",
    pending: "Оплата прошла. Выпуск домена ещё идёт — нажмите «Получить» ещё раз через минуту, повторно платить не придётся",
    attached: "Домен привязан",
    current: "Текущий домен",
  },
  publish: {
    title: "Публикация",
    publishing: "Публикуем сайт…",
    publishingHint: "Рендерим страницу и загружаем её в TON Storage. Обычно это занимает до минуты.",
    published: "Сайт опубликован",
    publishedAt: "Опубликован {{date}}",
    error: "Не удалось опубликовать",
    retry: "Попробовать снова",
    update: "Обновить сайт",
    updateHint: "Домен и ссылка не меняются, подписывать в кошельке ничего не нужно — посетители сразу увидят новую версию.",
    updated: "Сайт обновлён",
    hasChanges: "Есть правки, которых ещё нет на опубликованном сайте. Обновите его, чтобы посетители их увидели.",
    stuck: "Публикация идёт дольше обычного. Похоже, задача потерялась — попробуйте ещё раз.",
    bagId: "ID в TON Storage",
    bindDns: "Привязать к домену",
    bindHint: "Подпишите транзакцию, чтобы домен отдавал новую версию сайта",
    domainReady: "Домен направлен на сайт — открывается в TON-браузере",
    bindSite: "Включить прямую отдачу",
    bindSiteHint: "Домен будет открываться напрямую с нашего сервера, без публичных шлюзов",
    bound: "Домен обновлён",
    openSite: "Открыть сайт",
    openHint: "Обычная ссылка — работает в любом браузере. Домен .ton откроется в TON-браузере после привязки.",
    trialNotice: "Первый сайт опубликован бесплатно на 7 дней. Дальше нужна подписка.",
    subscriptionRequired: "Для публикации нужна активная подписка",
  },
  tariffs: {
    title: "Тарифы",
    subtitle: "Оплата в Gram — списывается с подключённого кошелька",
    sitesLimit_one: "{{count}} сайт",
    sitesLimit_few: "{{count}} сайта",
    sitesLimit_many: "{{count}} сайтов",
    duration: {
      month: "месяц",
      "3month": "3 месяца",
      "6month": "6 месяцев",
      "12month": "год",
      forever: "бессрочно",
    },
    // короткие подписи для переключателя срока на витрине
    durationShort: {
      month: "1 мес",
      "3month": "3 мес",
      "6month": "6 мес",
      "12month": "12 мес",
      forever: "Навсегда",
    },
    per: {
      month: "в месяц",
      "3month": "за 3 месяца",
      "6month": "за 6 месяцев",
      "12month": "за год",
      forever: "разовый платёж",
    },
    noOption: "нет на этот срок",
    priceNote: "Чем длиннее срок, тем дешевле месяц. «Навсегда» — разовый платёж без продлений.",
    buy: "Оформить",
    paying: "Ждём подпись в кошельке…",
    confirming: "Проверяем платёж в блокчейне…",
    success: "Подписка активирована",
    recovered: "Прошлая оплата нашлась в сети и засчитана: {{names}}. Платить второй раз не нужно",
    empty: "Администратор ещё не настроил тарифы",
  },
  subscriptions: {
    title: "Мои подписки",
    empty: "Активных подписок нет",
    trial: "Пробный период",
    manual: "Выдана администратором",
    until: "до {{date}}",
    forever: "бессрочно",
    renew: "Продлить",
    status: {
      active: "Активна",
      expiring_soon: "Скоро закончится",
      expired: "Закончилась",
      manual: "Выдана вручную",
    },
    expiringNotice: "Подписка заканчивается {{date}} — продлите, чтобы сайт остался опубликованным",
    expiredNotice: "Подписка закончилась, сайты сняты с публикации",
  },
  settings: {
    title: "Профиль",
    wallet: "Кошелёк TON",
    walletHint: "Нужен для оплаты и владения доменом",
    notConnected: "Не подключён",
    proofFailed: "Кошелёк подключён, но подтвердить владение не удалось. Попробуйте ещё раз или переподключите кошелёк.",
    language: "Язык",
    theme: "Тема",
    themeLight: "Светлая",
    themeDark: "Тёмная",
    about: "Об авторе проекта",
    version: "Версия",
    resetDemo: "Сбросить демо-данные",
  },
  about: {
    title: "Об авторе проекта",
    hint: "Кто сделал приложение и как связаться",
    open: "Открыть",
    failed: "Не удалось загрузить страницу автора",
  },
  admin: {
    title: "Админка",
    tabs: {
      stats: "Статистика",
      users: "Пользователи",
      tariffs: "Тарифы",
      domains: "Домены",
      zone: "Зона",
      about: "Об авторе",
    },
    about: {
      hint: "Этот текст и ссылку пользователи видят в разделе «Об авторе проекта».",
      name: "Заголовок",
      text: "Текст",
      linkUrl: "Ссылка",
      linkHint: "Профиль в Telegram, сайт или почта — оставьте пустым, чтобы скрыть кнопку",
      linkLabel: "Текст кнопки",
    },
    stats: {
      users: "Пользователи",
      sites: "Сайты",
      published: "Опубликовано",
      subscriptions: "Активные подписки",
      revenue: "Оборот, Gram",
      revenue30: "За 30 дней, Gram",
      payments: "Платежей",
    },
    users: {
      search: "Поиск по нику, id или кошельку",
      empty: "Никого не найдено",
      sites: "сайтов",
      subs: "подписок",
      grant: "Выдать доступ",
      revoke: "Отозвать",
      granted: "Доступ выдан",
      revoked: "Доступ отозван",
      wallet: "Кошелёк",
      registered: "Регистрация",
      payments: "Платежи",
      noPayments: "Платежей нет",
    },
    grant: {
      title: "Выдать доступ",
      tariff: "Тариф",
      manual: "Свой лимит",
      sitesLimit: "Лимит сайтов",
      duration: "Срок",
      comment: "Комментарий",
      submit: "Выдать",
    },
    tariffs: {
      oneTime: "разово",
      create: "Новый тариф",
      name: "Название",
      description: "Описание",
      price: "Цена, Gram",
      sitesLimit: "Лимит сайтов",
      duration: "Срок",
      kind: "Тип",
      active: "Активен",
      inactive: "Скрыт",
      deleteConfirm: "Удалить тариф «{{name}}»?",
      saved: "Тариф сохранён",
    },
    domains: { empty: "Доменов пока нет", owner: "Владелец" },
    zone: {
      hint: "Платформа владеет одним доменом .ton и один раз разворачивает на нём зону субдоменов. После этого пользователи получают адреса вида имя.вашдомен.ton.",
      status: "Состояние зоны",
      ready: "Готова",
      notReady: "Не настроена",
      domain: "Домен платформы",
      domainHint: "Например mysites.ton — им должен владеть кошелёк администратора",
      dnsItem: "Адрес DNS-item домена",
      dnsItemHint: "Адрес NFT этого домена в блокчейне",
      mode: "Как выдавать субдомены",
      modeHint: "Задаётся один раз транзакцией разворота и потом не меняется",
      modeSbt: "Сразу выпускать",
      modeProxy: "Через аукцион",
      modeLocked: "Зона уже развёрнута — тип менять поздно. Другой тип потребует разворота новой зоны на другом домене.",
      collection: "Адрес коллекции субдоменов",
      collectionHint: "Появляется после разворота зоны — впишите его сюда",
      deploy: "Развернуть зону",
      deployHint: "Разовая операция: транзакцию подписывает владелец домена",
      deployed: "Транзакция разворота отправлена",
    },
  },
  errors: {
    LIMIT_EXCEEDED: "Достигнут лимит сайтов по тарифу",
    SUBSCRIPTION_REQUIRED: "Нужна активная подписка",
    NOT_A_CUSTOM_CODE_SITE: "Свой код доступен только в проекте этого типа",
    WALLET_NOT_CONNECTED: "Подключите кошелёк TON",
    PAYMENT_NOT_CONFIRMED: "Платёж пока не найден в блокчейне. Подождите и повторите",
    TX_ALREADY_USED: "Эта транзакция уже использована",
    DOMAIN_TAKEN: "Домен уже занят",
    PUBLISH_IN_PROGRESS: "Сайт уже публикуется — подождите несколько секунд",
    ZONE_NOT_DEPLOYED: "Коллекция ещё не развёрнута — сначала подпишите транзакцию разворота зоны",
    NETWORK_ERROR: "Нет связи с сервером",
    INIT_DATA_INVALID: "Ошибка авторизации Telegram",
  },
};

export type Translations = typeof ru;
